import "./OtherScoreCards.css";
import ScoreCard from "./ScoreCard";
import { useAppSelector } from "./store";

function OtherScoreCards() {
  const players = useAppSelector((state) => {
    return state.players;
  });
  const userProfile = useAppSelector((state) => {
    return state.profile;
  });

  const otherPlayers = players.filter((player) => player.id !== userProfile.id);

  const otherScoreCards = otherPlayers.map((player) => {
    return (
      <div className="otherScoreCardContainer" key={player.id}>
        <ScoreCard
          key={player.id}
          scoreCard={player.scoreCard}
          size="small"
          playable={false}
          playerName={player.name}
        />
      </div>
    );
  });

  return <div className="otherScoreCards">{otherScoreCards}</div>;
}

export default OtherScoreCards;
